module.exports = __webpack_public_path__ + "img/quote-right.20326a50.png";